import { Link, useNavigate } from 'react-router-dom';
import './styles/Navbar.css';
import { useCart } from './Cart/Cart';
import logo from './Logo.png'
import { useState, useEffect, useRef } from 'react';

const Navbar = () => {
  const {cartItems} = useCart();
  const [search, setSearch] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const mobileMenuRef = useRef(null);
  const hamburgerRef = useRef(null);
  
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/search?q=${encodeURIComponent(search.trim())}`);
      setSearch('');
    }
  }; 

  const toggleMobileMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMobileMenuOpen(prev => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && 
          mobileMenuRef.current && 
          !mobileMenuRef.current.contains(event.target) &&
          hamburgerRef.current &&
          !hamburgerRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* HEADER */}
      <div className='nav-bar'>
        <header className="bg-white shadow-md">
          <div className="main-container">
            <div className="logo-container">
              <Link to="/" onClick={closeMobileMenu}>
                <img className="logo-image" src={logo} alt="PartyOne Logo" />
              </Link>
            </div>
            
            <form className="search-bar flex" onSubmit={handleSearchSubmit}>
              <input
                type="text"
                className="search-input"
                placeholder="Search by event, birthday, party..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              <button type="submit" className="search-button">
                <img src="https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/search.svg" alt="Search Icon" width="20" height="20" />
              </button>
            </form>

            <div className="header-actions">
              {/* Cart */}
              <Link to="/cart" onClick={closeMobileMenu}>
                <button className="cart-button flex items-center gap-1">
                  <img src="https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/shopping-cart.svg" alt="Cart Icon" width="20" height="20" />
                  <span className="cart-count">{cartItems.length}</span>
                </button>
              </Link> 

              <Link to="/login" className="login-button desktop-only" onClick={closeMobileMenu}>
                Login
              </Link>

              <div className="location-button desktop-only flex items-center gap-1">
                <img src="https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/map-pin.svg" alt="Location Icon" width="20" height="20" />
                <select>
                  <option value="hyderabad">Hyderabad</option>
                  <option value="hindupur">Hindupur</option>
                  <option value="anantapur">Anantapur</option>
                  <option value="mumbai">Nellore</option>
                  <option value="bengalore">Bengaluru</option>
                  <option value="delhi">Delhi</option>
                </select>
              </div>

              {/* Mobile Menu Toggle */}
              <button   
                ref={hamburgerRef}
                className="mobile-menu-toggle"
                onClick={toggleMobileMenu}
                aria-label="Toggle mobile menu"
                aria-expanded={isMobileMenuOpen}
              >
                <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            </div>
          </div>
        </header>

        {/* DESKTOP NAVIGATION */}
        <div className="nav desktop-nav">
          <div className="bg-red-600">
            
            <div className="container">
              <ul className="nav-list">
                <li className="nav-item">
                  <Link to="/birthday" className="nav-link">Birthday</Link>
                </li>
                <li className="nav-item">
                  <Link to="/decorations" className="nav-link">Decorations</Link>
                </li>
                <li className="nav-item">
                  <Link to="/candlelight-dinners" className="nav-link">Candlelight Dinners</Link>
                </li>
                <li className="nav-item">
                  <Link to="/Prvt-theater-celebration" className="nav-link">Private Theater Celebration</Link>
                </li>
                <li className="nav-item">
                  <Link to="/festiv-decor" className="nav-link">Festival Decorations</Link>
                </li>
                <li className="nav-item">
                  <Link to="/corporate-planner" className="nav-link">Corporate Planner</Link>
                </li>
                <li className="nav-item">
                  <Link to="/occasions" className="nav-link">Occasions</Link>
                </li>
                <li className="nav-item">
                  <Link to="/recent-bookings" className="nav-link">Recent Bookings</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* MOBILE MENU */}
        {isMobileMenuOpen && (
          <>
            <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
            <div ref={mobileMenuRef} className="mobile-menu">
              {/* Close Button Header */}
              <div className="mobile-menu-header">
                <h3 className="mobile-menu-title">Menu</h3>
                <button 
                  className="mobile-menu-close" 
                  onClick={closeMobileMenu}
                  aria-label="Close mobile menu"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                    
                  </svg>
                </button>
              </div>

              <ul className="mobile-nav-list">
                
                <li className="mobile-nav-item">
                  <Link to="/birthday" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">🎂</span>
                    Birthday
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/decorations" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">🎨</span>
                    Decorations
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/candlelight-dinners" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">🕯️</span>
                    Candlelight Dinners
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/Prvt-theater-celebration" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">🎬</span>
                    Private Theater Celebration
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/festiv-decor" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">🎪</span>
                    Festival Decorations
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/corporate-planner" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">💼</span>
                    Corporate Planner
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/occasions" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">🎉</span>
                    Occasions
                  </Link>
                </li>
                <li className="mobile-nav-item">
                  <Link to="/recent-bookings" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">📋</span>
                    Recent Bookings
                  </Link>
                </li>
                
                {/* Divider */}
                <li className="mobile-nav-divider"></li>
                
                <li className="mobile-nav-item mobile-extra">
                  <Link to="/login" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <span className="mobile-nav-icon">👤</span>
                    Login
                  </Link>
                </li>
                <li className="mobile-nav-item mobile-extra">
                  <div className="mobile-location">
                    <span className="mobile-nav-icon">📍</span>
                    <select onChange={closeMobileMenu}>
                      <option value="hyderabad">Hyderabad</option>
                      <option value="hindupur">Hindupur</option>
                      <option value="anantapur">Anantapur</option>
                      <option value="mumbai">Nellore</option>
                      <option value="bengalore">Bengaluru</option>
                      <option value="delhi">Delhi</option>
                    </select>
                  </div>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Navbar;